"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castenedolo": {
    "9ba86ce9": [{
      "hkey": "461f1867",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "centro-alpino": [{
      "hkey": "461f1867",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7448021f": [{
      "hkey": "2c812391",
      "slug": "castenedolo",
      "name": "Castenedolo",
      "primary": true,
      "skipSearch": false
    }],
    "finiletti-san-giustina": [{
      "hkey": "2c812391",
      "slug": "castenedolo",
      "name": "Castenedolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5994e0e2": [{
      "hkey": "53bae483",
      "slug": "macina",
      "name": "Macina",
      "primary": true,
      "skipSearch": false
    }],
    "macina-bodea": [{
      "hkey": "53bae483",
      "slug": "macina",
      "name": "Macina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4e6c754b": [{
      "hkey": "2c812391",
      "slug": "castenedolo",
      "name": "Castenedolo",
      "primary": true,
      "skipSearch": false
    }],
    "san-giustina-finiletti-rodenga": [{
      "hkey": "2c812391",
      "slug": "castenedolo",
      "name": "Castenedolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;